import React, { Fragment } from "react";
import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import {
  ddlAPIMethods,
  setFormValue,
} from "../../../../redux/slices/importdatasetpageslice";
import {
  FormDropDownList,
  FormDropDownListById,
  FormInput,
} from "../../../../forms/form-components";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@progress/kendo-react-buttons";
import { timeIntervalsDDL } from "../../../../redux/slices/createdatasetpageslice";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ImportFromApiStep = (props) => {
  const { formValues } = props;
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.importDatasetPage);
  const headers = pageState.formValues.Headers;
  const currentTheme = useSelector((state) => state.currentTheme);
  const { t } = useTranslation();

  // Function to clear all headers
  function handleClearHeaders(event) {
    event.preventDefault();
    dispatch(setFormValue({ id: "Headers", value: [{ key: "", value: "" }] }));
  }

  // Function to add a new header
  function handleAddHeaders(event) {
    event.preventDefault();
    const newHeader = { key: "", value: "" }; // New header with key-value pair
    const updatedHeaders = [...headers, newHeader];
    dispatch(setFormValue({ id: "Headers", value: updatedHeaders }));
  }

  // Function to delete a specific header
  function handleDeleteHeader(event, index) {
    event.preventDefault();
    const updatedHeaders = headers.filter((_, idx) => idx !== index);
    dispatch(
      setFormValue({
        id: "Headers",
        value: updatedHeaders.length
          ? updatedHeaders
          : [{ key: "", value: "" }],
      })
    );
  }

  // Function to handle changes in headers
  function handleHeaderChange(index, field, value) {
    const updatedHeaders = headers.map((header, idx) =>
      idx === index ? { ...header, [field]: value } : header
    );
    dispatch(setFormValue({ id: "Headers", value: updatedHeaders }));
  }

  return (
    <FormRegion>
      <div className="form-group form-group-1">
        <div className="k-form-field">
          <label className="k-label k-text-disabled">{t("datasets.importdataset.selected")}</label>
          <div className="k-form-field-wrap">
            <input
              disabled={true}
              name="SelectedDataset"
              id="SelectedDataset"
              className="k-input k-input-md k-rounded-md k-input-solid"
              value={
                pageState.lst_of_datasets.find(
                  (option) =>
                    option.Id === Number(pageState.formValues.SelectedDataset)
                )?.Title
              }
            />
          </div>
        </div>
        <Field
          id={"Url"}
          name={"Url"}
          label={t("datasets.importdataset.url")}
          component={FormInput}
          onChange={(e) =>
            dispatch(setFormValue({ id: "Url", value: e.value }))
          }
        />
        <Field
          id={"Method"}
          name={"Method"}
          label={t("datasets.importdataset.method")}
          component={FormDropDownListById}
          data={ddlAPIMethods}
          dataItemKey="Id"
          textField="Title"
          onChange={(e) =>
            dispatch(setFormValue({ id: "Method", value: e.value }))
          }
        />

        <Field
          id={"ReccursEvery"}
          name={"ReccursEvery"}
          label={t("datasets.importdataset.recurs")}
          component={FormDropDownList}
          data={timeIntervalsDDL}
          dataItemKey="Id"
          textField="Title"
          onChange={(e) =>
            dispatch(setFormValue({ id: "ReccursEvery", value: e.value }))
          }
        />
        <div
          className="k-form-field"
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <label id="Headers_label" htmlFor="Headers" className="k-label">
            {t("datasets.importdataset.headers")}
          </label>
          <div  >
            <Button
              onClick={(e) => handleClearHeaders(e)}
              style={{ marginLeft: "20px" }}
            >
              {t("datasets.importdataset.clear")}
            </Button>
            <Button onClick={(e) => handleAddHeaders(e)}>{t("datasets.importdataset.add")}</Button>
          </div>
        </div>

        <Fragment>
          {/* Directly call loadHeaders(headers) */}
          <div className="headers-container">
            {headers.map((header, index) => (
              <div
                key={`header-${index}`}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "15px",
                }}
              >
                <Field
                  component={FormInput}
                  id={`Headers[${index}].key`}
                  name={`Headers[${index}].key`}
                  label={t("datasets.importdataset.key")}
                  value={header.key}
                  onChange={(e) =>
                    handleHeaderChange(index, "key", e.target.value)
                  }
                />
                <Field
                  component={FormInput}
                  id={`Headers[${index}].value`}
                  name={`Headers[${index}].value`}
                  label={t("datasets.importdataset.value")}
                  value={header.value}
                  onChange={(e) =>
                    handleHeaderChange(index, "value", e.target.value)
                  }
                />
                <Button onClick={(e) => handleDeleteHeader(e, index)}>
                  {t("datasets.importdataset.delete")}
                </Button>
              </div>
            ))}
          </div>
        </Fragment>
      </div>
      <style>
        {`
          .headers-container {
            padding: 20px;
            border: ${currentTheme.managerBorder};
          }
          .datasets-page > .content .headers-container .k-form-field {
            margin-top: 0 !important;
          }
          .datasets-page > .content .headers-container .k-button {
            height: 30px;
            margin-top: 24px;
          }
        `}
      </style>
    </FormRegion>
  );
};

export default ImportFromApiStep;
